module.exports = __webpack_public_path__ + "img/SMT_17_Mr_Gary_Ong_Chin_Boon.13b704e7.jpg";